/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { InspectorControls, RichText, useBlockProps } from '@wordpress/block-editor';
import { Panel, PanelBody, TextControl, ToggleControl, RadioControl } from '@wordpress/components';
import ServerSideRender from '@wordpress/server-side-render';
import { useState } from '@wordpress/element';
import { Spinner } from '@wordpress/components';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit( { attributes, isSelected, setAttributes } ) {
    const { faqtitle, faqsearch, faqplaceholder, faqdisplayall, faqaccordion, faqorderby, faqorder } = attributes;
    return [
        <InspectorControls>
            <Panel>
                <PanelBody
                    title={ __( 'FAQ Settings', 'wpfb' ) }
                    icon="admin-plugins"
                >   
                    <TextControl
                        label={ __( 'FAQ Title', 'wpfb' ) }
                        help={ __( 'FAQ Title.', 'wpfb' ) }
                        onChange={ ( faqtitle ) => setAttributes( { faqtitle: faqtitle } ) }
                        value={ attributes.faqtitle }
                    />
                    <ToggleControl
                        checked={ faqsearch }
                        label={ __( 'Searchbox', 'wpfb' ) }
                        help={ __( 'If the searchBox is set to enable it will show on the front end..', 'wpfb' ) }
                        onChange={ ( faqsearch ) => setAttributes( { faqsearch : faqsearch } ) }
                    />
                    {
                        faqsearch ? 
                        <TextControl
                            label={ __( 'Searchbox placeholder', 'wpfb' ) }
                            help={ __( 'Searchbox placeholder', 'wpfb' ) }
                            onChange={ ( faqplaceholder ) => setAttributes( { faqplaceholder : faqplaceholder } ) }
                            value={ faqplaceholder }
                        />
                        : ''
                    }
                   
                    <RadioControl
                        label="Ordering"
                        help="Order By"
                        selected={ attributes.faqorderby }
                        options={ [
                            { label: 'Created Date', value: 'date' },
                            { label: 'Title', value: 'title' }                        ] }
                        onChange={ ( value ) => { setAttributes( { faqorderby:value } ) } }                    
                    />

                    <RadioControl
                        label="Sort Ordering"
                        help="A->Z"
                        selected={ attributes.faqorder }
                        options={ [
                            { label: 'Ascending', value: 'asc' },
                            { label: 'Descending', value: 'desc' },
                        ] }
                        onChange={ ( value ) => { setAttributes( { faqorder:value } ) } }                    
                    />
                    
                    <ToggleControl
                        checked={ faqaccordion }
                        label={ __( 'FAQ Accordion', 'wpfb' ) }
                        help={ __( 'FAQ Accordion', 'wpfb' ) }
                        onChange={ ( faqaccordion ) => setAttributes( { faqaccordion : faqaccordion } ) }
                    />
                    <ToggleControl
                        checked={ faqdisplayall }
                        label={ __( 'Display All Answers', 'wpfb' ) }
                        help={ __( 'Display All Answers', 'wpfb' ) }
                        onChange={ ( faqdisplayall ) => setAttributes( { faqdisplayall : faqdisplayall } ) }
                    />
                </PanelBody>
            </Panel>
        </InspectorControls>,
          
        <div { ...useBlockProps() }>
             <ServerSideRender
                    block="create-block/wpfaqblock"
                    attributes={ { ...attributes } }
                />
        </div>
    ];

}
